import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { getBillingLinkCall, getSubscriptionCall } from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [getSubscriptionCall.saga, getBillingLinkCall.saga];

export function* billingRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
